import React from 'react';

import BenchlingConfig from 'BenchlingConfig';

import * as NewUserFlowActions from './NewUserFlowActions';
import ProclaimedCommercialRoleInfoScreen from './ProclaimedCommercialRoleInfoScreen';
import VPCRoleInfoScreen from './VPCRoleInfoScreen';

interface Props {
  inGettingStartedFlow: boolean;
  initialPhoneNumber?: string;
  initialTeamName?: string;
  initialTitle?: string;
  isLoading: boolean;
}

export interface UserInfoState {
  phoneNumber: string | null;
  title: string | null;
  teamName: string | null;
  company: string | null;
}

class RoleInfoScreen extends React.Component<Props> {
  static defaultProps = {inGettingStartedFlow: false};

  _handleClickNextScreen = (e: React.FormEvent<HTMLFormElement>, userInfo: UserInfoState): void => {
    e.preventDefault();
    NewUserFlowActions.submitRoleDetails(
      {
        phoneNumber: userInfo.phoneNumber,
        title: userInfo.title,
        teamName: userInfo.teamName,
        company: userInfo.company,
      },
      this.props.inGettingStartedFlow
    );
  };

  override render(): JSX.Element {
    return (
      <div>
        <div className="infoScreen-container row">
          <div className="roleInfoScreen-left col-md-6">
            <div className="hidden-xs hidden-sm">
              <img src="/static/img/enterprise/lab-notebook.png" className="roleInfoScreen-img" />
            </div>
          </div>
          <div className="roleInfoScreen-right col-md-6">
            <h1>Set up your profile</h1>
            <p>
              Benchling allows you to collaborate with other users in your organization. Let's set up your
              profile before getting started with Benchling.
              {BenchlingConfig.ENABLE_ONBOARDING_ROLE_INFO && (
                <span>
                  {' '}
                  In order to match you with the right team at your company, please fill out the following
                  information.
                </span>
              )}
            </p>
            {BenchlingConfig.ENABLE_ONBOARDING_ROLE_INFO ? (
              <VPCRoleInfoScreen
                initialPhoneNumber={this.props.initialPhoneNumber}
                initialTeamName={this.props.initialTeamName}
                initialTitle={this.props.initialTitle}
                isLoading={this.props.isLoading}
                onSubmit={this._handleClickNextScreen}
              />
            ) : (
              <ProclaimedCommercialRoleInfoScreen
                isLoading={this.props.isLoading}
                handleClickNextScreen={this._handleClickNextScreen}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default RoleInfoScreen;
